__webpack_require__.p = "https://dap-b2bpemakt-dap-rewrite.vercel.app/_next/";